'use client'
import { useState } from 'react'

export function ShareButton({ url, title, label = 'Share', copiedLabel = 'Copied!' }: {
  url: string
  title: string
  label?: string
  copiedLabel?: string
}) {
  const [copied, setCopied] = useState(false)

  async function handleShare() {
    if (navigator.share) {
      try {
        await navigator.share({ title, url })
        return
      } catch {}
    }
    await navigator.clipboard.writeText(url)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <button type="button" className="ed-btn-ghost" onClick={handleShare}>
      {copied ? copiedLabel : label}
    </button>
  )
}
